// <Shopify Product Id: number>, <Partner Price: number>
const partnerProducts = new Map();

// Phantom
partnerProducts.set(7354478919739, 1299.00);

// Silver
// partnerProducts.set(7354479083579, 799.00);

// Shield
partnerProducts.set(7354479181883, 329.00);

// Filtered Earplugs
partnerProducts.set(7354478821435, 225.00);

// Solid Earplugs
partnerProducts.set(7354478886971, 149.00);

// High Frequency Earplugs
partnerProducts.set(7354478854203, 150.00);

// Swim Earplugs
partnerProducts.set(7354479116347, 149.00);

// Sleeping Earplugs
partnerProducts.set(7354479214651, 149.00);

// Special Pricing logic is located in card-product.liquid and main-product.liquid
// <Partner url parameter code>, <Partner info>
const specialPricing = new Map();

specialPricing.set("cigna-5490f88c8119", {
    // Sheild
    7354479181883: 299.00
});

// <Partner url parameter code>, <Partner info>
const partnerMap = new Map();

partnerMap.set("starkey-testing", {
    clubName: "Starkey Testing",
    code: "starkey-5432",
    logoSrc: "/cdn/shop/files/pheasants-forever-logo.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("pheasants-forever", {
    clubName: "Pheasants Forever",
    logoSrc: "/cdn/shop/files/pheasants-forever-logo.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("delta-waterfowl", {
    clubName: "Delta Waterfowl",
    logoSrc: "/cdn/shop/files/logo-delta-waterfowl.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("hms-motorsport", {
    clubName: "HMS Motorsport",
    logoSrc: "/cdn/shop/files/logo-hms-motorsport.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("jgr", {
    clubName: "Joe Gibbs Racing",
    logoSrc: "/cdn/shop/files/jgr-block-logo.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("trd", {
    clubName: "Toyota Racing Development",
    logoSrc: "/cdn/shop/files/logo-trd.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("onx-hunt", {
    clubName: "Onx Hunt",
    logoSrc: "/cdn/shop/files/logo-onx-hunt.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("fsa", {
    clubName: "Florida Sheriffs Association",
    logoSrc: "/cdn/shop/files/logo-florida-sheriffs-association.webp",
    logoWidth: 378,
    logoHeight: 173
});

partnerMap.set("mcsa", {
    clubName: "Major County Sheriffs of America",
    logoSrc: "/cdn/shop/files/logo-mcsa.webp",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("nsa", {
    clubName: "National Sheriffs' Association",
    logoSrc: "/cdn/shop/files/logo-nsa-gold-partner.webp",
    logoWidth: 200,
    logoHeight: 150
});

partnerMap.set("zmax", {
    clubName: "ZMax Cars Tour",
    logoSrc: "/cdn/shop/files/logo-zmax-cars-tour.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("racing-electronics", {
    clubName: "Racing Electronics",
    logoSrc: "/cdn/shop/files/racing-electronics-logo.svg",
    logoWidth: 350,
    logoHeight: 200
});

partnerMap.set("usa-ffc32ba1ed22", {
    clubName: "Union Sportsmen's Alliance",
    code: "sh-usa-dyswhl",
    welcomeMessage: "Sportsmen know, more than anyone, how important hearing is to their success and safety. As a member of Union Sportsman Alliance you have access to significant savings.",
    logoSrc: "/cdn/shop/files/union-sportsmens-alliance-logo.svg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("mvb-caf4a3818aca", {
    clubName: "My Vet Benefits",
    code: "sh-mvb-tjluyom",
    logoSrc: "/cdn/shop/files/mvb-logo.webp",
    logoWidth: 400,
    logoHeight: 144
});

partnerMap.set("nra-e2753ac73384", {
    clubName: "National Rifle Association",
    code: "SH-NRA-2025",
    logoSrc: "/cdn/shop/files/nra-logo.webp",
    logoWidth: 400,
    logoHeight: 148
});

partnerMap.set("sfb-ff407bca095e", {
    clubName: "Farm Bureau",
    code: "sh-sfb-flmtrarc",
    logoSrc: "/cdn/shop/files/sh-sg-og.jpg",
    logoWidth: 250,
    logoHeight: 250
});

partnerMap.set("ncl-3d2596688d95", {
    clubName: "National Coalition of Labor",
    code: "sh-ncl-sftumus",
    logoSrc: "/cdn/shop/files/ncl-logo.svg",
    logoWidth: 385,
    logoHeight: 167
});

partnerMap.set("kms-a3648832f76d", {
    clubName: "Kalitta Motorsports",
    code: "sh-kms-drag-racing",
    logoSrc: "/cdn/shop/files/kalitta-motorsports.png",
    logoWidth: 400,
    logoHeight: 62
});

partnerMap.set("ka-0b3560c6b298", {
    clubName: "Kalitta Air",
    code: "sh-k-air",
    logoSrc: "https://cdn.shopify.com/s/files/1/0600/3317/1515/files/kap-logo.jpg?v=1779160057",
    logoWidth: 400,
    logoHeight: 33
});

partnerMap.set("cigna-5490f88c8119", {
    clubName: "Cigna",
    displayClubNameInGreeting: false,
    welcomeMessage: "We want to thank you for partnering with SoundGear to protect and enhance your hearing health. We're offering customers through Cigna Healthcare Healthy Rewards® a special discount on select products.",
    pricingTitle: "Cigna Healthy Rewards Pricing",
    code: "sh-cigna-health",
    greeting: "Healthy Rewards Customers",
    logoSrc: "/cdn/shop/files/cigna-logo.jpg",
    logoWidth: 438,
    logoHeight: 240
});

partnerMap.set("start-hearing-f59852614fb1", {
    clubName: "Start Hearing",
    code: "sh-partner-member",
    greeting: "Start Hearing partner",
});

partnerMap.set("sh-motorsports-1a13932c8843", {
    clubName: "Start Hearing Motorsports",
    code: "sh-motorsports",
    greeting: "Motorsports Members",
});

partnerMap.set("union-plus-ddaa9fd40906", {
    clubName: "Union Plus",
    code: "union-plus",
    logoWidth: 250,
    logoHeight: 225,
    logoSrc: "/cdn/shop/files/union-plus.png",
});

partnerMap.set("amac=4c43aa72ff54", {
    clubName: "AMAC",
    code: "amac-starthearing",
    logoWidth: 348,
    logoHeight: 133,
    logoSrc: "/cdn/shop/files/amac-logo.png",
});

const getPartnerInfo = () => JSON.parse(sessionStorage.getItem("partner-info"));

const setPartnerInfo = (property, value) => {    
    const currentSessionStorage = getPartnerInfo();
    currentSessionStorage[property] = value;
    sessionStorage.setItem("partner-info", JSON.stringify(currentSessionStorage));
}

const emptyShoppingCart = async () => {
    await fetch("/cart/clear.json", {
        method: "POST",
        headers: { "Accept": "application/json" }
    });
};

const applyDiscount = () => {
    const partnerDiscountCode = getPartnerInfo().code;
    const discountURL = `/discount/${partnerDiscountCode}`;
    setPartnerInfo("discountWasAutoApplied", "true");
    window.location = discountURL;
}

const kickUserOut = () => {
    emptyShoppingCart();
    window.location.replace("https://soundgear.com");
}

const validateVisit = () => {
    // Inside Shopify's Theme Editor.
    if (window.location.host.includes("myshopify")) {
        return;
    }

    let writeSession = true;

    // Returns partnerToken string or null.
    const partnerToken = (() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const partnerTokenFromParams = params.get("partner");

        // Token is in url parameter.
        if (!!partnerTokenFromParams && partnerMap.has(partnerTokenFromParams)) {
            return partnerTokenFromParams;
        }

        // Token is not in url, it may be in session.
        const sessionPartnerInfo = getPartnerInfo();

        // Session storage is undefined.
        if (!sessionPartnerInfo) {
            return null;
        }

        const partnerTokenFromSession = sessionPartnerInfo.partnerToken;

        // Token is in session storage. Do not overwrite session.
        if (!!partnerTokenFromSession && partnerMap.has(partnerTokenFromSession)) {
            writeSession = false;
            return partnerTokenFromSession;
        }

        // Token is not in url or session.
        return null;
    })();

    if (partnerToken === null) {
        // Unverified user. Redirect to SoundGear.com
        kickUserOut();
        return;
    } 

    // Verified user.

    if (writeSession) {
        sessionStorage.setItem("partner-info", JSON.stringify(partnerMap.get(partnerToken)));
        setPartnerInfo("partnerToken", partnerToken);
    }

    document.documentElement.setAttribute("data-partner", getPartnerInfo().clubName);

    const discountHasNotBeenApplied = getPartnerInfo().discountWasAutoApplied !== "true";

    if (discountHasNotBeenApplied) {
        applyDiscount();
    }
}

validateVisit();

const updateStrings = () => {
    const pricingTitle = getPartnerInfo().pricingTitle;

    if (pricingTitle) {
        const partnerPricingTitleElements = document.querySelectorAll(`.partner-pricing-title`);
        if (!partnerPricingTitleElements.length) return;

        partnerPricingTitleElements.forEach(titleElement => {
            titleElement.textContent = pricingTitle;
        });
    }
}

const handleContentLoaded = () => {
    updateStrings();
}

document.addEventListener("DOMContentLoaded", handleContentLoaded);